import React from 'react';
import IconButton from '../IconButton/IconButton';

export default function AlarmClockIcon() {
    return <IconButton icon="alarm-clock" />;
}
